<template>
  <div>
    <main class="main">
      <button @click="backStep" class="button button-back"><span>Back</span></button>

      <div class="confirm-wrapper">
        <div v-html="content" class="wysiwyg"></div>
      </div>

    </main>
  </div>
</template>

<script>
import Footer from '@/components/Footer'

export default {
  name: 'page-template',
  components: {Footer},
  props: ['slug'],
  data () {
    return {
      content: '<p></p>'
    }
  },
  watch: {
    '$route.params.slug' (newSlug, oldSlug) {
      this.getDetails(this.slug)
    }
  },
  created () {
    this.getDetails(this.slug)
    console.log(this.slug)
  },
  mounted () {
    this.$store.state.isLoading = false
  },
  methods: {
    backStep () {
      this.$router.push({ path: '/home' })
    },
    getDetails (slug) {
      console.log('method', this.slug)
      this.$http.pageDetails(this.slug)
        .then((res) => {
          if (res.status !== undefined) {
            console.log(res.data.content)
            this.content = res.data.content
          } else {
            console.log('inside error', res.response.data.message)
          }
        })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../scss/variables.scss";
  .main {
    position: relative;
    min-height: auto;
    margin: 0;
    padding: 20px 6% 80px;
    text-align: center;
  }

  .confirm-wrapper {
    text-align: left;
  }

</style>
